import { AreaChart, Area, XAxis, ResponsiveContainer, Tooltip } from "recharts";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { ChartTooltip } from "@/shared/ui/ChartTooltip";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { conversionData } from "../data";

export function SignupsChart() {
  const { tick } = useChartTheme();
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.landing.signupsConversions} className="col-span-full md:col-span-2">
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={conversionData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="signupGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#13c2c2" stopOpacity={0.25} />
              <stop offset="100%" stopColor="#13c2c2" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="week"
            axisLine={false}
            tickLine={false}
            tick={{ fill: tick, fontSize: 12 }}
            dy={8}
            tickFormatter={(v) => t.common.months[v] ?? v}
          />
          <Tooltip content={<ChartTooltip />} />
          <Area type="monotone" dataKey="signups" stroke="#13c2c2" strokeWidth={2.5} fill="url(#signupGrad)" />
          <Area type="monotone" dataKey="conversions" stroke="#4680ff" strokeWidth={2} fill="transparent" />
        </AreaChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
